import {
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  LOGIN_REQUEST,
  LOG_OUT
} from '../constants/actionTypes';

const sessionData = sessionStorage.getItem('userInfo');
const data = {
  isLoggedIn: false,
  isloading: false,
  userDetails: null,
  isNewUser: false,
  error: null
};
const initialState = sessionData === null ? data : JSON.parse(sessionData);

export function user(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case LOGIN_REQUEST:
      return {
        ...state,
        isLoggedIn: false,
        userDetails: null,
        isloading: true,
        isNewUser: false,
        error: null
      };

    case LOGIN_SUCCESS:
      const successState = {
        ...state,
        isLoggedIn: true,
        userDetails: payload.userDetails,
        isloading: false,
        error: null
      };
      sessionStorage.setItem('userInfo', JSON.stringify(successState));
      return {
        ...state,
        isLoggedIn: true,
        userDetails: payload.userDetails,
        isloading: false,
        error: null
      };
    case LOGIN_FAILURE:
      let message = payload.message;
      if (typeof message === 'object') {
        message = 'Unknown error occured';
      }
      return {
        ...state,
        isLoggedIn: false,
        userDetails: null,
        isloading: false,
        isNewUser: false,
        error: message
      };
    case LOG_OUT:
      return data;
    default:
      return state;
  }
}
